import styled from 'styled-components'

export const CodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Code = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  background-color: ${props => props.theme.colors.background.secondary};
  color: ${props => props.theme.colors.outline.default};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius1};

  svg {
    min-width: ${props => props.theme.size.XXS};
    color: ${props => props.theme.colors.text.default};
  }

  button {
    border: none;
    background-color: transparent;
    border-radius: 50px;
    padding: ${props => props.theme.spacing.sp4};
    :hover {
      color: ${props => props.theme.colors.text.inverse};
    }
  }
`
